<div #shopenergy id="shopenergy" class="getstarted">
  <main role="main" class="maincnt mainmrg">
    <div class="getbannersect sectppad pb-2" id="getStartPage">
      <div class="sectpad container">
        <ul class="navigate nav">
          <li class="active"><a href="javascript:void(0)" id="link_1" (click)="getslide(shopenergy)"></a></li>
          <li><a href="javascript:void(0)" id="link_2" (click)="getslide(onestop)"></a></li>
          <li><a href="javascript:void(0)" id="link_3" (click)="getslide(recommendation)"></a></li>
          <li><a href="javascript:void(0)" id="link_4" (click)="getslide(signup)"></a></li>
        </ul>
        <div  class="col-12 row m-0 sections pl-0">
          <div class="bannertext col-sm-8 mt-3">
            <h1>Shop for Energy<br/>
            Save with Confidence</h1>
            <div class="bannerdesc mblnhgt mt-2 mob-mt-0">Energy service for renters and <br> homeowners powered by AI </div>
          </div>
          <div class="col-sm-4 bannerimg drag-drop mb-4 text-right mob-center mob-mb-0">
            <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482169/Static%20images/Residential-getStarted/hi_muw58j.svg" alt="Illustration of the word Hi in pink" title="Hi illustration" width="280" />
          </div>
        </div>
      </div>
    </div>
    <div #onestop id="onestop" class="onesect sections">
      <div class="sectpad container text-center">
        <div class="row">
        <div class="col-sm-3 col-12 subsect text-center pb-3 mt-4 drag-drop mob-mt-0">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482216/Static%20images/Residential-getStarted/onestopimg_rhtyuv.svg" alt="Shopping cart illustration in residential energy yellow background" title="Shopping cart illustration" class="img-responsive" width="220">
        </div>
        <div class="col-sm-9 col-12 pt-4 subsect text-right">
          <h1 class="font67 getonesec mt-4 pt-5 mob-pt-0">One Stop,<br>
            Comparison Shop</h1>
          <p class="desc font25 getpara mblnhgt webview">If it makes sense,
            it saves you dollars </p>
            <p class="desc font25 getpara mblnhgt mbSaveDollar mobileview">If it makes sense, it
               <br> saves you dollars </p>
        </div>
      </div>
      </div>
    </div>
    <div #recommendation id="recommendation" class="recommendatesect sections">
      <div class="sectpad container">
        <div class="row">
        <div class="col-sm-7 col-12 subsect textsec getpadd">
          <h1 class="font67 fntwgtbld clrfff gethgt mt-4 pt-4">Get an Honest
            Recommendation</h1>
          <p class="desc font25 fntwgtnrml clrfff mblnhgt">Eva, our delightful AI bot, will recommend an energy plan that fits your
            budget, lifestyle and household</p>
        </div>
        <div class="col-sm-5 col-12 subsect pt-4 imgsec drag-drop mb-4 text-right mob-center">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482246/Static%20images/Residential-getStarted/recommendationimg_xfet6k.svg" alt="Charcoal Eva logo in residential energy pink background" title="Charcoal Eva logo in residential energy pink background" width="245" />
        </div>
    </div>

      </div>
    </div>
    <div #signup id="signup" class="signupsect pb-5 mob-pb-0 sections">
      <div class="sectpad container text-center">
        <div class="row">
        <div class="col-sm-3 col-12 signupimg pt-0 imgsec drag-drop pt-4 mob-pt-0">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482320/Static%20images/Residential-getStarted/signupimg_ec6t05.svg" alt="Illustration of lightbulb looking like a piggy bank" title="Lightbulb bank illustration" width="238" />
        </div>
        <div class="col-sm-9 col-12 mt-5 mob-mt-0 subsect text-right textsec pt-5">
          <h1 class="font67 fntwgtbld gethgt mt-3 mob-mt-0 mbLineHgt" >Sign up &</h1>
          <h1 class="font67 fntwgtbld gethgt">Start Saving</h1>
          <p class="desc font25 minhgt0 fntclrcode0 fntwgtnrml mt-3 mob-mt-0 mblnhgt">What are you waiting for?</p>
          <div class="col-sm-12 subsect p-0 text-right signupget mb-5 webview">
            <a class=" btn btn-wpink-primary getstart btn  mb-3  p-2 wd220 font22 float mbright" style="position: fixed; border-color: #fff !important;" id = 'myBtn' (click)="getQuestionnaire()">GET STARTED</a>
          </div>
        </div>
      </div>
        <div class="col-sm-12 subsect p-0 text-right signupget mb-5 mobileview mbflt">
          <a class="btn btn-outline-primary mb-3 secondarybtn p-2 wd220 font22 mbright getstart-shadow" style="border-color: #ed1976 !important;color: #fff !important;background-color: #ed1976 !important;border-radius: 4px;" (click)="getQuestionnaire()">GET STARTED</a>
        </div>
      </div>
    </div>
  </main>
</div>